import { AppAreaConfig } from '@/funnels/@types'
import walkingMale from '../walking/activity-male-walking'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-male-tai-chi-walking',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['tai_chi_walking'],
	},
	landing: {
		ids: ['loader-tai-chi-walking-m', 'age-tai-chi-walking-m'],
		route: {
			path: '/tai-chi-walking-m',
			name: 'tai-chi-walking-male-funnel',
		},
	},
	funnel: {
		id: 'ob-male-tai-chi-walking',
		route: {
			path: '/tai-chi-walking-m/ob/:page(.*)?',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'male-activity-tai-chi-walking',
		},
		slug: 'activity-male-tai-chi-walking',
		theme: 'light',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl', 'ja'],
		redirectTo: {
			always: {
				appArea: walkingMale,
				page: 'focus-area',
			},
		},
	},
}

export default appAreaConfig
